import type { DashboardAggregatePayload } from '../../shared/dashboardAggregatePayload';
import { requestJson } from './requestJson';

export async function getDashboardAggregate(
  dashboardKey: string,
  bucketMs: number
): Promise<DashboardAggregatePayload> {
  return await requestJson(
    `/api/dashboard/${encodeURIComponent(dashboardKey)}?bucket_ms=${bucketMs}`
  );
}
